import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import AlertBox, { AlertVariant } from 'app/components/presentation/alert/AlertBox';
import { ButtonA, Size } from 'app/components/presentation/buttons/ButtonClassNameA';
import React, { ReactNode } from 'react';

export enum Severity {
  Error = 'error',
  Info = 'info',
}

interface ICallErrorMessageProps {
  buttonLabel?: string;
  buttonAction?: () => void;
  severity?: Severity;
  children: ReactNode;
}

const CallErrorMessage = ({
  buttonLabel,
  buttonAction,
  severity = Severity.Error,
  children,
}: ICallErrorMessageProps) => {
  const alertVariant =
    severity === Severity.Error ? AlertVariant.Danger :
    severity === Severity.Info ? AlertVariant.Info :
    AlertVariant.Warning;

  const childrenCss = [
    {
      flex: '1 1 80%',
      alignSelf: 'center',
    },
    {
      flex: '0 0 auto',
      alignSelf: 'center',
    },
  ];
  return (
    <AlertBox role="alert" shadow={false} variant={alertVariant}>
      <FlexMarginGroup
        childCss={(idx) => childrenCss[idx]}
        wrap
      >
        <div>
          {children}
        </div>
        {buttonAction && buttonLabel && (
          <div>
            <ButtonA onClick={buttonAction} size={Size.Tiny} type="button">
              {buttonLabel}
            </ButtonA>
          </div>
        )}
      </FlexMarginGroup>
    </AlertBox>
  );
};

export default CallErrorMessage;
